import React from 'react'
import styled from 'styled-components'

const CloseWrap = styled.div`
  cursor: pointer;
  width: 30px;
  height: 30px;
  transform: rotate(90deg);
  background-color: transparent;
  path {
    stroke-width: 3;
    stroke-linecap: round;
    stroke: #999;
  }
  #mask {
    opacity: 0;
    stroke: url(#colorTone);
  }
  :hover #mask {
    opacity: 1;
  }
`
export default function Close({ onClick }: { onClick: () => void }) {
  return (
    <CloseWrap className='close-wrap' onClick={onClick}>
      <svg viewBox='0 0 30 30'>
        <defs>
          <linearGradient id='colorTone'>
            <stop offset='0' stopColor={'#fb6b4a'} />
            <stop offset='1' stopColor={'#f97d60'} />
          </linearGradient>
        </defs>
        <path d='M 7,7 L 23,23 M 23,7 L 7,23' />
        <path id='mask' d='M 7,7 L 23,23 M 23,7 L 7,23' />
      </svg>
    </CloseWrap>
  )
}
